import config from '../../../config';
import { Session, SessionType } from '../interface';

export const createRefreshSessionsTimeout = (
  sessions: Session[],
  onRefresh: () => void
): ReturnType<typeof setTimeout> | undefined => {
  const firstSession = sessions.find(({ type }) => type !== SessionType.Replay);
  if (!firstSession) return;
  const diff = new Date(firstSession.date).getTime() - Date.now();
  const waitTime = diff + config.MINUTES_ALLOW_TO_REGISTER_AFTER_WEBINAR_START * 60 * 1000;
  if (waitTime > 60 * 60 * 1000) return;
  const timeout = setTimeout(async (): Promise<void> => {
    onRefresh();
  }, waitTime);
  return timeout;
};
